import { useEffect, useState } from "react";
import { toast } from "sonner";
import api from "@/lib/api";
import { Badge } from "@/components/ui/badge";
import { Skeleton } from "@/components/ui/skeleton";
import { Avatar, AvatarImage, AvatarFallback } from "@/components/ui/avatar";
import {
  Table, TableBody, TableCell, TableHead, TableHeader, TableRow,
} from "@/components/ui/table";

export const UsersTab = () => {
  const [rows, setRows] = useState(null);

  useEffect(() => {
    api
      .get("/admin/users")
      .then((r) => setRows(r.data))
      .catch(() => {
        setRows([]);
        toast.error("Could not load users");
      });
  }, []);

  if (rows === null) return <Skeleton className="h-40 w-full rounded-xl bg-[#15151A]" />;

  return (
    <div className="bg-[#15151A] border border-[#D4AF37]/20 rounded-xl overflow-x-auto" data-testid="admin-users-tab">
      <Table>
        <TableHeader>
          <TableRow className="border-white/10 hover:bg-transparent">
            <TableHead className="text-[#A0A0A0] uppercase text-xs tracking-widest">User</TableHead>
            <TableHead className="text-[#A0A0A0] uppercase text-xs tracking-widest">Email</TableHead>
            <TableHead className="text-[#A0A0A0] uppercase text-xs tracking-widest">Profile</TableHead>
            <TableHead className="text-[#A0A0A0] uppercase text-xs tracking-widest">WhatsApp</TableHead>
            <TableHead className="text-[#A0A0A0] uppercase text-xs tracking-widest">Status</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {rows.map((u) => (
            <TableRow key={u.user_id} className="border-white/5 hover:bg-white/5" data-testid="admin-user-row">
              <TableCell>
                <div className="flex items-center gap-3">
                  <Avatar className="w-9 h-9 border border-[#D4AF37]/30">
                    <AvatarImage src={u.photo} alt={u.name} />
                    <AvatarFallback className="bg-[#1A1A24] text-[#D4AF37] text-xs">{u.name?.[0] || "?"}</AvatarFallback>
                  </Avatar>
                  <div>
                    <p className="text-sm text-white">{u.name}</p>
                    {u.bio && <p className="text-xs text-[#A0A0A0] max-w-[220px] truncate">{u.bio}</p>}
                  </div>
                </div>
              </TableCell>
              <TableCell className="text-sm text-[#E0E0E0]">{u.email}</TableCell>
              <TableCell className="text-xs text-[#A0A0A0]">
                {[u.age, u.gender, u.neighborhood].filter(Boolean).join(" · ") || "—"}
              </TableCell>
              <TableCell className="text-sm text-[#E0E0E0]">{u.whatsapp || "—"}</TableCell>
              <TableCell>
                {u.is_admin ? (
                  <Badge className="bg-[#D4AF37] text-[#0B0B0F] text-[10px] uppercase border-transparent">Admin</Badge>
                ) : u.profile_completed ? (
                  <Badge className="bg-transparent border border-[#4CAF50]/60 text-[#4CAF50] text-[10px] uppercase">Complete</Badge>
                ) : (
                  <Badge className="bg-transparent border border-white/30 text-[#A0A0A0] text-[10px] uppercase">Incomplete</Badge>
                )}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  );
};
